// extracted by mini-css-extract-plugin
export default {"wrapper":"EditUserNameModal_wrapper__DR2fu","title":"EditUserNameModal_title__0yu+0","description":"EditUserNameModal_description__Q4wF0","shine":"EditUserNameModal_shine__VEet-"};